import { AlertCircle, CheckCircle2, Info } from "lucide-react";
import type { CompatibilityReport } from "../contract.js";

export function CompatibilityVerdict({ compatibility }: { compatibility: CompatibilityReport }) {
  const { channelDevices, matchingDevices, fingerprints } = compatibility;

  if (matchingDevices > 0) {
    return (
      <div className="flex items-center gap-2 rounded-lg border border-[#ABEFC6] bg-[#ECFDF3] p-3 text-xs text-[#027A48]">
        <CheckCircle2 className="size-4 shrink-0 text-[#17B26A]" />
        <span>
          <strong>{matchingDevices}</strong> dari {channelDevices} perangkat aktif akan menerima pembaruan ini.
        </span>
      </div>
    );
  }

  if (channelDevices > 0) {
    return (
      <div className="rounded-lg border border-[#FECDCA] bg-[#FEF3F2] p-3 text-xs text-[#B42318] space-y-2">
        <div className="flex items-start gap-2">
          <AlertCircle className="size-4 shrink-0 text-[#F04438] mt-0.5" />
          <p>
            <strong>Tidak ada perangkat aktif yang cocok dengan fingerprint bundle ini.</strong> Seluruh {channelDevices} perangkat yang terlihat di kanal ini melaporkan build native berbeda.
          </p>
        </div>
        <FingerprintTable rows={fingerprints} />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 rounded-lg border border-[#BFDBFE] bg-[#EFF4FF] p-3 text-xs text-[#1D4ED8]">
      <Info className="size-4 shrink-0 text-[#2563EB]" />
      <span>
        Belum ada perangkat yang melapor di kanal ini dalam 30 hari terakhir.
      </span>
    </div>
  );
}

export function FingerprintTable({ rows }: { rows: CompatibilityReport["fingerprints"] }) {
  if (rows.length === 0) return null;
  return (
    <div className="rounded border border-[#EAECF0] bg-white overflow-hidden mt-2">
      <table className="w-full text-left text-xs">
        <thead>
          <tr className="border-b border-[#EAECF0] bg-[#F6F7F9] text-[#667085]">
            <th className="py-1.5 px-2.5 font-medium">Fingerprint Perangkat</th>
            <th className="py-1.5 px-2.5 font-medium">Versi Native</th>
            <th className="py-1.5 px-2.5 font-medium text-right">Perangkat</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-[#EAECF0]">
          {rows.map((row) => (
            <tr key={row.fingerprint} className="font-mono text-[11px]">
              <td className="py-1.5 px-2.5 break-all text-[#475467]">{row.fingerprint}</td>
              <td className="py-1.5 px-2.5 text-[#101828]">{row.nativeVersion}</td>
              <td className="py-1.5 px-2.5 text-right font-medium text-[#101828]">{row.devices}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
